// NOTE: Check why @babel/preset-env with { useBuiltIns: 'usage', corejs: 3 } do not polyfill structuredClone !!!
import structuredClone from 'core-js-pure/actual/structured-clone.js';

/** @typedef {'intent' | 'view' | 'timing' | 'error' | 'event'} TrackEventType */

/**
 * @typedef {object} DigitalDataEventParams
 * @property {object} eventInfo
 * @property {string} eventInfo.eventAction
 * @property {TrackEventType} [eventInfo.type]
 * @property {number} [eventInfo.timeStamp]
 * @property {string} componentID
 * @property {object} attributes
 */

/**
 * Push a new event info DigitalData CEDDL
 *
 * @param {DigitalDataEventParams} params Event name or event detail
 */
export default function track({
  eventInfo: { eventAction, type = 'intent', timeStamp = Date.now(), ...eventInfo } = {},
  componentID = undefined,
  attributes = {},
  productID = undefined
}) {
  let attributesValue;
  if (productID === undefined || productID === null) {
    attributesValue = structuredClone(attributes);
  } else {
    attributesValue = {
      item: [
        {
          attributes: structuredClone(attributes),
          ...(productID && { productInfo: { productID } })
        }
      ]
    };
  }

  globalThis.digitalData?.event.push({
    eventInfo: {
      eventAction,
      type,
      timeStamp: new Date(timeStamp).toJSON(),
      ...eventInfo
    },
    attributes: attributesValue,
    ...(componentID != null && { componentID })
  });
}

/**
 * @param {TrackEventType} type
 * @param {string} action Event action
 * @param {string} componentID Component identifier
 * @param {object} attributes Event attributes (product infos, component ID, etc.)
 * @param {string} productID Product identifier
 */
function alias(type, action, componentID = undefined, attributes = undefined, productID = undefined) {
  if ('debug' in document.body.dataset) {
    console.log('alias: ', type, action, componentID, attributes, productID);
  }

  track({ eventInfo: { eventAction: action, type }, componentID, attributes, productID });
}

/**
 * Track user interaction: request from user (click, submit, select, add, remove, open, etc.) that doesn't always
 * succeed to a result (change)
 *
 * @function
 * @param {string} name Event name
 * @param {object} attributes Event attributes (product infos, component ID, etc.)
 * @param {string} productID Product identifier
 */
export const trackIntent = /*#__PURE__*/ alias.bind(this, 'intent');

/**
 * Track view changes (showing new content) about the UI / view (page, tab panel, dialog, disclosure, etc.)
 *
 * @function
 * @param {string} name Event name
 * @param {object} attributes Event attributes (product infos, component ID, etc.)
 * @param {string} productID Product identifier
 */
export const trackView = /*#__PURE__*/ alias.bind(this, 'view');

/**
 * Track errors or exceptions (fatal or not)
 *
 * @function
 * @param {string} name Event name
 * @param {object} attributes Event attributes (product infos, component ID, etc.)
 * @param {string} productID Product identifier
 */
export const trackError = /*#__PURE__*/ alias.bind(this, 'error');

/**
 * Track other events that doesn't fall in other types (application, debug, warning, etc.)
 *
 * @function
 * @param {string} name Event name
 * @param {object} attributes Event attributes (product infos, component ID, etc.)
 * @param {string} productID Product identifier
 */
export const trackEvent = /*#__PURE__*/ alias.bind(this, 'event');

/**
 * Track metrics events for measurements (user, navigation, resources, etc.)
 *
 * @function
 * @param {string} name Event name
 * @param {object} attributes Event attributes (product infos, component ID, etc.)
 * @param {string} productID Product identifier
 */
export const trackTiming = /*#__PURE__*/ alias.bind(this, 'timing');
